import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";

interface RouterLinkProps {
  to: string;
  preventScrollReset?: true | false;
  onClick?: () => void;
  className?: string;
}

function RouterLink(props: PropsWithChildren<RouterLinkProps>) {
  const onClick = () => {
    window.scrollTo(0, 0);

    if (props?.onClick !== undefined) props.onClick();
  };

  return (
    <Link
      to={props.to}
      preventScrollReset={props.preventScrollReset || false}
      onClick={onClick}
      className={props.className || ""}
    >
      {props.children}
    </Link>
  );
}

export default RouterLink;
